import { render } from "./ToggleableContent.vue?vue&type=template&id=05f88472"
import script from "./ToggleableContent.vue?vue&type=script&lang=js"
export * from "./ToggleableContent.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__